export enum OutputMimeType {
  pdf = 'application/pdf',
  jpg = 'image/jpeg',
  html = 'text/html',
  json = 'application/json',
}
